import { Link, useLocation } from 'react-router-dom';

/**
 * Site-wide footer. Quiet by design — the brutalist hero pages are loud, the
 * footer just provides the legal anchors required to launch. Hidden on
 * full-bleed operational screens (scan / promoter / organizer / admin / login).
 */
const HIDDEN_PREFIXES = ['/scan', '/admin', '/promoter', '/organizer', '/login', '/signup', '/forgot-password', '/reset-password'];

const Footer = () => {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#050505] border-t border-zinc-900 mt-16 sm:mt-24"
      data-testid="site-footer"
    >
      <div className="container mx-auto px-4 md:px-8 py-10 sm:py-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Link to="/" className="inline-block mb-3">
              <span className="font-['Josefin_Sans'] text-2xl font-bold text-[#B5FF00] tracking-tight">UNIGHT</span>
            </Link>
            <p className="text-zinc-500 text-sm max-w-md">
              The underground nightlife platform · UK &amp; India · Built for the dancefloor, run by the people on it.
            </p>
          </div>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-xs tracking-widest" aria-label="Legal">
            <Link
              to="/privacy"
              className="text-zinc-400 hover:text-[#B5FF00] transition-colors"
              data-testid="footer-privacy-link"
            >
              PRIVACY POLICY
            </Link>
            <Link
              to="/terms"
              className="text-zinc-400 hover:text-[#B5FF00] transition-colors"
              data-testid="footer-terms-link"
            >
              TERMS &amp; CONDITIONS
            </Link>
            <a
              href="mailto:support@unighttickets.com"
              className="text-zinc-400 hover:text-[#B5FF00] transition-colors"
              data-testid="footer-support-link"
            >
              SUPPORT
            </a>
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] text-zinc-600 tracking-widest">
          <span>© {year} UNIGHT TICKETS · ALL RIGHTS RESERVED</span>
          <span>v1.0 · BUILT IN BOMBAY</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
